<template>
  <activity-table>
    <thead>
      <tr>
        <th v-for="header in tableData.headers" :key="header.label">{{ header.label }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, idx) in tableData.rows" :key="idx">
        <td v-for="(value, vIdx) in row.values" :key="value.value">
          <tally-marks
            v-if="
              tableData.headers[vIdx] &&
                tableData.headers[vIdx].columnType === KeyboardingTableColumnType.TALLY_MARK
            "
            :value="value.value"
          ></tally-marks>
          <div v-else>{{ value.value }}</div>
        </td>
      </tr>
    </tbody>
  </activity-table>
</template>

<script>
import ActivityTable from './ActivityTable.vue';
import TallyMarks from './TallyMarks.vue';
import { KeyboardingTableColumnType } from '../../graph/types/schema-generated-types';

export default {
  props: {
    tableData: {
      type: Object,
      required: true
    }
  },
  data() {
    return { KeyboardingTableColumnType };
  },
  components: {
    ActivityTable,
    TallyMarks
  }
};
</script>

<style lang="scss" scoped></style>
